import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';

const SkeletonDetalleEmpleado = () => {
    return (
        <>
            <Card className="mb-2 shadow-sm">
                <Card.Header className="d-flex align-items-center">
                    <div className="flex-grow-1 d-flex justify-content-center">
                        <Skeleton circle width={40} height={40} className="me-2" />
                        <Skeleton width={300} height={30} />
                    </div>
                    <Skeleton width={120} height={35} borderRadius={8} />
                </Card.Header>
            </Card>

            <Card className="shadow-sm border-0" style={{ borderRadius: '15px' }}>
                <Card.Body className="p-4">
                    <Row className="align-items-start g-0">
                        <Col md={3} className="text-center">
                            <Skeleton width={130} height={173} borderRadius={12} />
                            <div className="mt-2 px-2 w-100">
                                <Skeleton width="80%" height={15} className="mb-1" />
                                <Skeleton width="60%" height={12} />
                            </div>
                        </Col>

                        <Col md={9} className="ps-3">
                            <Row className="g-3">
                                {/* Títulos simulados */}
                                <Col xs={6}><Skeleton width="40%" height={20} /></Col>
                                <Col xs={6}><Skeleton width="40%" height={20} /></Col>

                                {/* Campos de formulario simulados */}
                                {[1, 2, 3, 4, 5, 6].map((i) => (
                                    <Col sm={6} key={i}>
                                        <Skeleton width={100} height={10} className="mb-1" />
                                        <Skeleton height={35} />
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>
                </Card.Body>
                <Card.Footer className="bg-light border-top p-3">
                    <div className="d-flex justify-content-end gap-3">
                        <Skeleton width={110} height={40} borderRadius={8} />
                        <Skeleton width={110} height={40} borderRadius={8} />
                    </div>
                </Card.Footer>
            </Card>
        </>
    );
};

export default SkeletonDetalleEmpleado;